export const classes = {
    Hero: '히어로',
    'Dark Knight': '다크나이트',
    Paladin: '팔라딘',
    Bishop: '비숍',
    'Fire / Poison': '불독',
    'Ice / Lightning': '썬콜',
    Shadower: '섀도어',
    'Night Lord': '나이트로드',
    'Dual Blade': '듀얼블레이드',
    Bowmaster: '보우마스터',
    Marksman: '신궁',
    Pathfinder: '패스파인더',
    Buccaneer: '바이퍼',
    Corsair: '캡틴',
    Cannoneer: '캐논슈터',
    'Dawn Warrior': '소울마스터',
    'Blaze Wizard': '플레임위자드',
    'Night Walker': '나이트워커',
    'Wind Archer': '윈드브레이커',
    'Thunder Breaker': '스트라이커',
    Mihile: '미하일',
    Aran: '아란',
    Evan: '에반',
    Mercedes: '메르세데스',
    Luminous: '루미너스',
    Phantom: '팬텀',
    Shade: '은월',
    'Angelic Buster': '엔젤릭버스터',
    Kaiser: '카이저',
    Cadena: '카데나',
    Kain: '카인',
    Xenon: '제논',
    Mechanic: '메카닉',
    'Battle Mage': '배틀메이지',
    'Wild Hunter': '와일드헌터',
    Blaster: '블래스터',
    'Demon Avenger': '데몬 어벤저',
    'Demon Slayer': '데몬 슬레이어',
    Adele: '아델',
    Ark: '아크',
    Illium: '일리움',
    Khali: '칼리',
    Hoyoung: '호영',
    Lara: '라라',
    Kinesis: '키네시스',
    Zero: '제로',
}
